import { render, staticRenderFns } from "./ButtonReOpen.vue?vue&type=template&id=320a4e0b&"
import script from "./ButtonReOpen.vue?vue&type=script&lang=ts&"
export * from "./ButtonReOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports